import styled from '@emotion/styled';
import { shouldForwardProps } from '../../helpers';

const StyledImg = ({ ...props }) => {
  const { customPropsObj } = shouldForwardProps(props);

  return { ...customPropsObj };
};

export const Image = styled('img')(StyledImg);
